module.exports = __webpack_public_path__ + "static/media/Condor.a15b4b92.png";